var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 13,
    viewBox: "0 0 26 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5916 8.57025C21.7563 8.57025 22.7004 9.56186 22.7004 10.7851C22.7004 12.0083 21.7563 12.9999 20.5916 12.9999C19.4275 12.9986 18.4841 12.0077 18.4828 10.7851C18.4828 9.56186 19.4269 8.57025 20.5916 8.57025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.83465 5.72669L3.18512 4.59985C3.26522 4.56251 3.33302 4.50103 3.37998 4.42328L5.41678 1.01328C5.79611 0.377244 6.46259 -0.00635101 7.17716 7.95965e-05H15.4542C16.1004 -0.00198528 16.7106 0.312053 17.1051 0.849628L19.7244 4.45372C19.783 4.53608 19.866 4.59566 19.9604 4.62304L24.3381 5.8812C24.9633 6.06403 25.3942 6.66414 25.3898 7.34572V9.02712C25.3898 9.86416 24.767 10.5603 23.9699 10.5603H23.5885C23.4761 9.00482 22.2991 7.76861 20.8181 7.65056C19.1623 7.51858 17.7182 8.82128 17.5925 10.5603H8.11315C8.00075 9.00482 6.82372 7.76867 5.34269 7.65056C3.68696 7.51858 2.24283 8.82128 2.11717 10.5603H1.42002C0.622939 10.5603 4.46467e-05 9.86416 4.46467e-05 9.02712V7.10773C-0.00444912 6.51505 0.322136 5.97465 0.83465 5.72669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11408 8.57025C6.27875 8.57025 7.22289 9.56186 7.22289 10.7851C7.22289 12.0083 6.27875 12.9999 5.11413 12.9999C3.95002 12.9986 3.00661 12.0077 3.00527 10.7851C3.00527 9.56186 3.94946 8.57025 5.11408 8.57025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.78c04a76e60fd46b528449fff9bc976f.svg";
export { ForwardRef as ReactComponent };